import { render, staticRenderFns } from "./SettingsSubstitutesCount.vue?vue&type=template&id=40a1f7a4&"
import script from "./SettingsSubstitutesCount.vue?vue&type=script&lang=js&"
export * from "./SettingsSubstitutesCount.vue?vue&type=script&lang=js&"
import style0 from "./SettingsSubstitutesCount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports